"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActionButtons = void 0;
var routes_1 = require("../../../../../../constants/routes");
var IUser_1 = require("../../../../../../interfaces/IUser");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var permissions_1 = __importDefault(require("../../../../../../hooks/permissions"));
function useActionButtons() {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var permissions = (0, permissions_1.default)(IUser_1.IPermissions.SUBSCRIPTIONS);
    var actionButtons = (0, react_1.useMemo)(function () { return [
        permissions.canCreate && {
            iconClassname: "solar:add-circle-bold",
            label: "Add Subscription",
            onClick: function () {
                navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.SUBSCRIPTIONS_ROUTE).concat(routes_1.SUBSCRIPTION_ROUTE));
            },
        },
    ]; }, []);
    return (0, react_1.useMemo)(function () { return ({
        actionButtons: actionButtons,
    }); }, [actionButtons]);
}
exports.useActionButtons = useActionButtons;
